import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="17" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 2.5H3a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1v-10a1 1 0 00-1-1zm-10 1h10v4.84l-1.54-1.55a1 1 0 00-1.42 0l-6.7 6.71H3v-10zm2 3a1 1 0 112 0 1 1 0 01-2 0z" fill="#fff" /></svg>);